import {
	Section,
	ItemSectionTitle,
	ItemSectionSubtitle,
	ItemSectionTop,
} from './Section';
import { getListedEntryKey } from '../../../../utils/getListedEntryKey';
import { IBlogSectionEntry } from '../../../../contentful/types/IBlogSectionEntry';
import { IBlogItemEntry } from '../../../../contentful/types/IBlogItemEntry';
import BlogCard from '../../../../components/common/cards/Blog/BlogCard';
import { getCardImageSource } from '../../../../utils/getCardImageSource';
import { BlogCardContainer } from '../../../../components/common/cards/Blog/BlogCardContainer';
import ViewButton from '../../../../components/common/button/ViewButton';
import { PageRoutes } from '../../../app/pages/domain/constants/PageRoutes';

interface IBlogsSectionProps {
	section: IBlogSectionEntry;
}

export default function BlogsSection({ section }: IBlogsSectionProps) {
	return (
		<Section>
			<ItemSectionTop>
				<div>
					{section?.fields?.subtitle && (
						<ItemSectionSubtitle>
							{section?.fields?.subtitle}
						</ItemSectionSubtitle>
					)}
					{section?.fields?.title && (
						<ItemSectionTitle>{section.fields.title}</ItemSectionTitle>
					)}
				</div>
				<ViewButton label="View all" href={PageRoutes.Blogs} />
			</ItemSectionTop>

			<BlogCardContainer>
				{section?.fields?.items?.map((item: IBlogItemEntry, index: number) => (
					<BlogCard
						key={getListedEntryKey(item, index)}
						title={item.fields.title}
						imageSource={getCardImageSource(item.fields.image)}
						imageAlt={
							item.fields.image?.fields.description ??
							item.fields.image?.fields.title
						}
						linkHref={`${PageRoutes.Blogs}/item/${item.fields.slug}`}
						body={item.fields.body}
					/>
				))}
			</BlogCardContainer>
		</Section>
	);
}
